// extracted by mini-css-extract-plugin
export default {"app":"pvCG_v","scrollable":"l7pLjR"};